import { render, staticRenderFns } from "./resources.component.html?vue&type=template&id=9cd7759c&scoped=true&"
import script from "./resources.component.ts?vue&type=script&lang=ts&"
export * from "./resources.component.ts?vue&type=script&lang=ts&"
import style0 from "./resources.component.scss?vue&type=style&index=0&id=9cd7759c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd7759c",
  null
  
)

export default component.exports